export class DeliveryPoints {
	constructor (response) {
		var deliveryPoints = []
		response.body.data.forEach(r => {
			deliveryPoints.push(this.parseData(r, response))
		})
		return deliveryPoints
	}

	parseData (data, response) {
	    if (!data) {
	    	
			return null
	    }

	    if (data.relationships) {
		    Object.keys(data.relationships).map((relationship, key) => {
		        data.attributes[relationship] = this.parseData(response.body.included.find((include) => {
		        	if (Array.isArray(data.relationships[relationship].data)) {
		        		var type = data.relationships[relationship].data[0].type
		        		var id =  data.relationships[relationship].data[0].id
		        	} else {
		        		var type  = data.relationships[relationship].data.type
		        		var id  = data.relationships[relationship].data.id
		        	}

		          	return include.type === type && include.id === id
		        }), response)
		    })
		}

	    data = {...{id: data.id}, ...data.attributes}
	    return data;
	}

	// parse (response){
	//     var body = response.body

	//     if (Array.isArray(body.data)) {
	// 		for (let i in body.data) {
	// 			body.data[i] = this.parseData(body.data[i], response)
	// 		}
	//        } else if (_.isObject(body.data)) {
	//     } else {
	//         body.data = this.parseData(body.data, response)
	//     }

	//     response.body = body

	//     return response
	// }
} 
